import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Utils } from 'app/components/utils/Utils';
import { AppService } from 'app/services/app/app.service';
import { EventsService } from '../../../services/events/events.service';
import { Item, StockModel } from 'app/models/stock-model';
import { ModeEnum } from 'app/components/shared/offer-locker/offer-locker.component';
import { Subscription } from 'rxjs';
import { Log } from 'app/core/logging/log';



@Component({
  selector: 'app-locker-type',
  templateUrl: './locker-type.page.html',
  styleUrls: ['./locker-type.page.scss'],
})
export class LockerTypePage implements OnInit {

  currentStock$: Subscription;
  typeLocker: Item[] = [];
  mode = ModeEnum.LINK_TYPE;

  constructor(
    private appService: AppService,
    private router: Router,
    private eventsService: EventsService
  ) {}

  ngOnInit() {   
    this.currentStock$ = this.appService.currentStock$.subscribe((stock:StockModel)=>{
      Log.info("stockType", {stock});
      this.typeLocker = Utils.getTypeLockers(stock);
    });
  }

  ngAfterViewInit(){
    this.eventsService.publish('refreshStep', { title: "1/4", nameBt: null });
  }

  ngOnDestroy() {
    this.currentStock$.unsubscribe();
  }

  msgError(error:any){
    if(error.code == 502){
      this.appService.showDangerToast(error.description);
      this.router.navigate(['landing']);
    }
  }

  categoryCallBack({item, param}:{item:Item, param:any}){
    Log.debug('categoryCallBack', {item, param});

    if(this.isBranch(item)){
      this.typeLocker = item.items;
    }else{
      this.router.navigate(['/reserve', this.appService.kiosk, 'locker-date'], {
        queryParams: param 
      });
    }

  }


  isBranch(item:Item){
    if(item.items == null || item.items.length == 0){
      return false;
    }
    return item.items.filter(f => f.items.length > 0).length > 0;
  }

}
